query ListBimClassRevisions (
    $id: ID!
) {
    bimClasses(
        filter: {
            id: $id
        }
    ) {
        id
        revisionID

        metadata {
            createdAt
            tags
        }
    }
}
